import moment from 'moment'
import { daysInAWeek } from 'lib/constants'

interface getMatchProps {
  dates: string[]
  day?: string
  customDates?: string[]
  weekNumberInMonth?: number
  groupOfDays?: string[]
}

// Finding match for given day
export function getGivenDayMatch({ dates, day }: getMatchProps) {
  const matchDays = []

  dates?.forEach((date) => {
    const daySplit = date.split('-')
    if (daySplit[2].search(day) !== -1) {
      matchDays.push(date)
    }
  })
  return matchDays
}

// Get week in a month and group of days match
export function getWeekInMonthAndGroupOfDaysMatch({
  dates,
  weekNumberInMonth,
  groupOfDays,
}: getMatchProps) {
  const matchDays = []
  const groupOfDayValue = []

  daysInAWeek.forEach((day, index) => {
    groupOfDays?.forEach((dayInGroup) => {
      if (day === dayInGroup) {
        groupOfDayValue.push(index.toString())
      }
    })
  })

  dates?.forEach((date) => {
    const currentDay = moment(date).format('D')
    const week = Math.ceil(Number(currentDay) / 7)
    if (Number(week) === Number(weekNumberInMonth)) {
      const day = moment(date).day()
      if (
        groupOfDayValue.length > 0 &&
        groupOfDayValue?.includes(day.toString())
      ) {
        matchDays.push(date)
      }
    }
  })

  return matchDays
}

//  Get group of days match
export function getGroupOfDaysMatch({ dates, groupOfDays }: getMatchProps) {
  const matchDays = []
  const groupOfDayValue = []

  daysInAWeek.forEach((day, index) => {
    groupOfDays?.forEach((dayInGroup) => {
      if (day === dayInGroup) {
        groupOfDayValue.push(index.toString())
      }
    })
  })
  if (groupOfDayValue.length === 7) {
    return dates
  } else {
    dates?.forEach((date) => {
      const day = moment(date).day()
      if (groupOfDayValue?.includes(day.toString())) {
        matchDays.push(date)
      }
    })
  }
  return matchDays
}

// Finding match for given any date or date's
export function getAnyMatchDates({ dates, customDates }: getMatchProps) {
  const matchDays = []
  const splitDates = []

  // Split TimeDate to date
  dates?.forEach((date) => {
    const daySplit = date.split('T00:00:00')
    splitDates.push(daySplit[0].toString())
  })
  if (splitDates.length > 0) {
    // Find match for given day
    splitDates.forEach((date) => {
      if (customDates?.includes(date)) {
        matchDays.push(moment(date).format('YYYY-MM-DDT00:00:00'))
      }
    })
  }
  return matchDays
}
